export default {
  allEdu: [],
};
